module.exports = __webpack_public_path__ + "img/FINANCEPR3.4078371d.png";